@if (propertyIsSet) {
  <lib-comparables-header
    [(showMap)]="showMap"
    [showMapToggle]="showMapToggle"
    (filterChanged)="pullComps($event)"
    (toggleMap)="toggleMap()"
  ></lib-comparables-header>
  <ion-content
    id="comparables-view"
    data-test-id="comparablesView"
    class="Comparables"
  >
    @if (addressIsValid) {
      <section
        class="Comparables__MapAndTableContainer"
        [ngClass]="{ 'Comparables__MapAndTableContainer--NoMap': !showMap }"
      >
        <div class="Comparables__ListSection">
          @if (!error) {
            <ion-card>
              <ion-card-content>
                <smartflip-comparables-filter-actions
                  [pullCompsButtonText]="getCompsButtonText"
                  [selectedComps]="selectedComps"
                  [arvButtonText]="calculateARVButtonText"
                  [filterOptions]="currentFilters"
                  (pullCompsClicked)="pullComps($event)"
                ></smartflip-comparables-filter-actions>

                @if (loadingComps$ | async) {
                  <div class="Comparables__SpinnerWrapper">
                    <ion-spinner class="Comparables__Spinner"></ion-spinner>
                  </div>
                } @else {
                  @if (compsList$ | async; as compsList) {
                    @if (compsList.length > 0) {
                      <div
                        class="container-fluid Comparables__List"
                        data-test-id="comparablesList"
                        id="comparables-list"
                      >
                        <app-comparables-table
                          class="Comparables__CompsTable"
                          [compsSource]="compsList"
                          [highlightedAddress]="highlightedAddress$ | async"
                          (selectionChange)="updateCompsSelected($event)"
                          (hoverChange)="onHoverChange($event)"
                        ></app-comparables-table>
                      </div>
                    } @else {
                      <p
                        class="warning"
                        [innerHTML]="comparablesWarningMessage"
                      ></p>
                    }
                  } @else {
                    <div class="container-fluid">
                      <p [innerHTML]="comparablesInstructions"></p>
                    </div>
                  }
                }
              </ion-card-content>
            </ion-card>
          } @else {
            <p class="warning" [innerHTML]="errorText"></p>
          }
        </div>

        <!-- Google Maps Section-->
        @if (showMap) {
          <div
            class="Comparables__MapSection"
            data-test-id="comparablesMapSection"
            id="comparables-map"
          >
            @if (this.comparablesMarkers) {
              <lib-interactive-map
                [lat]="location[0]"
                [long]="location[1]"
                [locations]="comparablesMarkers"
                [startingLocationLabel]="currentPropertyLabel"
                (markerSelected)="highlightPropertyInList($event)"
              ></lib-interactive-map>
            }
          </div>
        }
      </section>
    } @else {
      <p class="warning" [innerHTML]="enterAddressWarning"></p>
    }
  </ion-content>
}
